<template>
  <div class="about">
    <h2>Progression du développement</h2>
    <iframe class="airtable-embed" src="https://airtable.com/embed/shrw1XhmQYibiWjbi?backgroundColor=orange" frameborder="0" onmousewheel="" width="100%" height="533" style="background: transparent; border: 1px solid #ccc;"></iframe>
    <h2>Derniers commits</h2>
    <div v-for="c in commits" :key="c.sha">
      <p>{{(new Date(c.commit.author.date)).toLocaleDateString()}} : <a :href="c.html_url">{{c.commit.message}}</a></p>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      commits: []
    }
  },
  mounted: function () {
    fetch(`https://api.github.com/repos/Karalix/explore-tablet/commits`)
      .then((resp) => {
        return resp.json()
      })
      .then((data) => {
        this.commits = data
      })
  }
}
</script>
